const cleanList = (items) =>
  Array.isArray(items)
    ? items.filter((item) => String(item || "").trim().length > 0)
    : [];

export const getLeadStatus = (drr) => {
  if (!drr) return "needs";
  const intakeProfile = drr.intake_profile;
  if (intakeProfile && typeof intakeProfile === "object") {
    const missingInfo = cleanList(intakeProfile.missing_info);
    const reviewStatus = String(intakeProfile.review_status || "").toLowerCase();
    const blockersCount = cleanList(drr.potential_blockers).length;
    if (reviewStatus.includes("blocker") || blockersCount > 0) return "mismatch";
    if (intakeProfile.is_ready_for_follow_up && missingInfo.length === 0) return "ready";
    return "needs";
  }
  const blockersCount = cleanList(drr.potential_blockers).length;
  if (blockersCount > 0) return "mismatch";
  const hasSummary =
    String(drr.summary || "").trim().length > 0 || cleanList(drr.next_steps).length > 0;
  const hasConstraints = cleanList(drr.key_constraints).length > 0;
  const hasAvailability = cleanList(drr.availability_compensation).length > 0;
  const hasExperience = cleanList(drr.relevant_experience).length > 0;
  const missingCore = !hasSummary || !hasConstraints || !hasAvailability || !hasExperience;
  return missingCore ? "needs" : "ready";
};

export const getCallReadyStats = (leads, resolveDrr) =>
  (leads || []).reduce(
    (acc, lead) => {
      const status = getLeadStatus(resolveDrr(lead));
      if (status === "ready") acc.ready += 1;
      if (status === "needs") acc.needs += 1;
      if (status === "mismatch") acc.mismatch += 1;
      return acc;
    },
    { ready: 0, needs: 0, mismatch: 0 }
  );
